module.exports = __webpack_public_path__ + "static/media/step-0.4fb086d3.png";